import { FC, useState } from 'react';

import {
  Loading,
  LoadingStatuses,
  ScreenSize,
  TabData,
  TabItem,
  Tabs,
  useMediaQuery,
} from '@argenta/react-ui';
import { t } from '@lingui/macro';

import { VacanciesOverview } from '../../components/VacanciesOverview';
import {
  SearchFilterFormValues,
  VacanciesSearchFilter,
  VacancyFilterMode,
} from '../../components/VacanciesSearchFilter';
import { useFetchVacancies } from '../../hooks/api/useFetchVacancies';
import { useAutoRedirectVacancyDetails } from '../../hooks/navigation/useAutoRedirect';

import { SearchFilterValues } from './SearchVacancies.types';
import { mapTabLocations } from './SearchVacancies.utils';

import './SearchVacancies.styles.scss';

export const SearchVacancies: FC = () => {
  const [indexTabLocation, setIndexTabLocation] = useState<number>(0);
  const [searchFilter, setSearchFilter] = useState<SearchFilterValues>({});
  const isMobileScreen = useMediaQuery({ maxWidth: ScreenSize.MEDIUM });

  const { vacancies, loadingStatus } = useFetchVacancies({ searchFilter });

  useAutoRedirectVacancyDetails();

  const onTabChangeHandler = ({ index }: TabData): void => {
    setIndexTabLocation(index);
  };

  const handleFormSubmit = (filterData: SearchFilterFormValues): void => {
    setSearchFilter({
      location: mapTabLocations(indexTabLocation),
      sector: filterData.sector?.value,
      searchTerm: filterData.searchTerm,
      postalCode: filterData.postalCode?.value.slice(0, 4),
      township: filterData.postalCode?.value.slice(7),
    });
  };
  const getFilterModeForTab = (): VacancyFilterMode => {
    switch (indexTabLocation) {
      case 1: {
        return VacancyFilterMode.HQ;
      }
      case 2: {
        return VacancyFilterMode.AGENCY;
      }
      default: {
        return VacancyFilterMode.ALL;
      }
    }
  };

  const tabContent = (
    <div className="argnt-vacancies-search-overview">
      <VacanciesSearchFilter
        onSearch={handleFormSubmit}
        showPostalCode={indexTabLocation !== 1}
        isLoading={loadingStatus === LoadingStatuses.LOADING}
        filterMode={getFilterModeForTab()}
      />
      <Loading
        loadingStatus={loadingStatus}
        i18nStrings={{ defaultErrorMessage: t({ id: 'vacancies.global.error.defaultMessage' }) }}
      >
        <VacanciesOverview vacancies={vacancies} enablePager />
      </Loading>
    </div>
  );

  const tabs: TabItem[] = [
    { label: t({ id: 'vacancies.search.filter.ALL' }) },
    { label: t({ id: 'vacancies.search.filter.HQ' }) },
    { label: t({ id: 'vacancies.search.filter.AGENCY' }) },
  ];

  return (
    <div className="argnt-vacancies-search">
      <Tabs
        items={tabs}
        onChange={onTabChangeHandler}
        mobile={isMobileScreen}
        renderContent={() => tabContent}
      />
    </div>
  );
};
